import type { TransferRecord } from '../types/transfer'

/**
 * Build React transfer wizard URL matching Angular `transfer-process-list.component.html` edit button:
 * `routerLink="/transfer/{{ fk_property_id || fk_company_id }}"`
 * `[queryParams]="status === 'Completed' ? { status, process_id: id } : {}"`
 * `fragment="{{ process_name }}"`
 */
export function buildTransferWizardPathFromListRow(row: TransferRecord): string | null {
  const entityId =
    row.fk_property_id != null
      ? String(row.fk_property_id)
      : row.fk_company_id != null
        ? String(row.fk_company_id)
        : row.property_id != null
          ? String(row.property_id)
          : row.company_id != null
            ? String(row.company_id)
            : null
  if (!entityId) return null

  const params = new URLSearchParams()
  if (row.status === 'Completed') {
    params.set('status', 'Completed')
    params.set('process_id', String(row.id))
  }
  const search = params.toString()
  const hash = row.process_name ? `#${row.process_name}` : ''
  return `/transfer/${entityId}${search ? `?${search}` : ''}${hash}`
}
